import React, { useEffect, useState } from 'react';
import { CustomerAddress } from '../models/superbit-api-models';
import { SimulatorModel } from '../models/SimulatorModel';
import AutoCompleteCities from '../components/AutoCompleteCities';
import { Select } from 'antd';
import { set } from 'lodash';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { IDNameDescriptionDictionary } from '../models/Site';

type Props = {
    config: any;
    customerAddress: CustomerAddress;
    index: number;
};

const ClientAddress = (props: Props) => {
    const simulatorModel: SimulatorModel = new SimulatorModel();
    
    const [clientAddress, setClientAddress] = useState<CustomerAddress>(props.customerAddress);
    const [streetsList, setStreetsList] = useState<any[]>([]);
    const [addressErrors, setAddressErrors] = useState({
        city: false,
        street: false,
        houseNumber: false,
        mailbox: false,
        postalCode: false,
        addressType: false,
    });
    const [fieldRequired, setFieldRequired] = useState<string>('*שדה חובה');
    const [dataState, setDataState] = useState<boolean>(false);
    const [postalcodeErrMsg, setPostalcodeErrMsg] = useState<string>("");
    const [postalLoading, setPostalLoading] = useState<boolean>(false);
    const [addressTypes, setAddressTypes] = useState<IDNameDescriptionDictionary>(new IDNameDescriptionDictionary());

    useEffect(() => {
        const fetchAddressTypes = async () => {
            const types = await simulatorModel.getAddressTypes();
            setAddressTypes(types);
        };
        fetchAddressTypes();


        if(props.customerAddress.city && props.customerAddress.city != "") {
            updateSteetsList(props.customerAddress.city.trim());
        }

    }, []);
    

    const onParamChange = async (name: string, value: string) => {
        const address = clientAddress;
        const errors = addressErrors;

        checkAddress(clientAddress);

        console.log('name', name, value)
        if(name == 'city'){
            errors.city = false;
            console.log('onParamChange', name, value)
            updateSteetsList(value);
        }if(name == 'street'){
            errors.street = false;
        }if(name == 'houseNumber'){
            errors.houseNumber = false;
        }if(name == 'mailbox'){
            errors.mailbox = false;
        }
        // switch (name) {
        //     case 'city':
        //         errors.city = false;
        //         errors.street = false;
        //         errors.houseNumber = false;
        //         errors.mailbox = false;
        //         errors.postalCode = false;
        //         setStreetsList([]);
        //         address.city = value;
        //         address.street = '';
        //         address.houseNumber = undefined;
        //         address.apartmentNumber = undefined;
        //         address.postalCode = undefined;
        //         address.mailbox = undefined;
        //         setClientAddress(address);
        //         updateSteetsList(value);
        //         setAddressErrors(errors);         
        //         break;
        //     case 'street':
        //         errors.street = false;
        //         errors.houseNumber = false;
        //         errors.mailbox = false;
        //         address.street = value;
        //         setClientAddress(address);
        //         setAddressErrors(errors);         
        //         break;
        //     case 'house':
        //         errors.houseNumber = false;
        //         address.houseNumber = parseInt(value);
        //         setClientAddress(address);
        //         setAddressErrors(errors);         
        //         break;
        //     case 'appartment':
        //         address.apartmentNumber = parseInt(value);
        //         setClientAddress(address);
        //         break;
        //     case 'postalCode':
        //         address.postalCode = value;
        //         setClientAddress(address);
        //         break;
        //     case 'mailbox':
        //         errors.mailbox = false;
        //         address.mailbox = value;
        //         setClientAddress(address);
        //         setAddressErrors(errors);         
        //         break;
        //     default:
        //         break;
        // }
        
        await setAddressErrors(errors);
        if(name === 'city' && value == ""){
            let address = {...clientAddress};
            address.city = "";
            address.street = "";
            address.houseNumber = 0;
            address.apartmentNumber = 0;
            address.entry = "";
            address.mailbox = "";
            address.postalCode = "";
            await setClientAddress(new CustomerAddress(address));
        }else{
            if((name === 'houseNumber' || name == 'apartmentNumber') && value == "" ){
                value = "0";
            }
            await setClientAddress(new CustomerAddress({...clientAddress, [name]: value}));
        }
       
    }

    const checkAddress = (address: CustomerAddress) => {
        // 
        const addressData = clientAddress;
        const errors = addressErrors;
        console.log('checkAddress errors', addressErrors)
        let hasError = false;
        if (!address.city || address.city == '') {
            errors.city = true;
            addressData.hasError = true
            hasError = true;   
        } 
        if((!address.street || address.street == '')  && (!address.mailbox || address.mailbox == '')) {
            errors.street = true;
            errors.mailbox = true;
            errors.houseNumber = true;
            addressData.hasError = true;
            hasError = true;        
            
        } 
        if ((!address.houseNumber || address.houseNumber == 0 || (typeof address.houseNumber === "string" && address.houseNumber === "")) 
            && (!address.mailbox || address.mailbox == '')) {
            errors.houseNumber = true;
            errors.mailbox = true;
            addressData.hasError = true;
            hasError = true;
        }
        if(!hasError) {
            console.log('hasError', address)
            addressData.hasError = false;
            errors.city = false;
            errors.street = false;
            errors.houseNumber = false;
            errors.mailbox = false;
        }
        setAddressErrors(errors);
        setClientAddress(addressData);
    
        
        console.log('Client Address errors', errors)
    }

    const onChange = () => {
        if(props.config.onChange) {
            const address = clientAddress;
            // checkAddress(clientAddress);
            if (addressErrors.city || addressErrors.street || addressErrors.houseNumber || addressErrors.mailbox) {
                address.hasError = true;
            } else {
                address.hasError = false;
            }
            setClientAddress(address);  

            props.config.onChange(address);
        }
    }



    const onDelete = () => {
        if (props.config.onDelete) {
            props.config.onDelete();
        }
    }

    const updateSteetsList = async (city: string) => {
        await setStreetsList([]);
        if (city) {
            console.log('updateSteetsList city', city)
        
            const streets = await simulatorModel.getStreetsAutocomplete(city);
            console.log('updateSteetsList streets', streets)
            await setStreetsList(streets);
          }
        
    }

    const checkHouseNumber = () => {
        const address = clientAddress;
        const errors = addressErrors;
        if (!address.houseNumber || address.houseNumber== 0 || (typeof address.houseNumber === "string" && address.houseNumber === "")) {
            errors.houseNumber = true;
        } else {
            errors.mailbox = false;
        }
        setAddressErrors(errors);
        props.config.onChange(address);
        getPostalCode();
    }

    const onHouseNumberFocus = () => {
        const address = clientAddress;
        const errors = addressErrors;
        errors.houseNumber = address.houseNumber && (typeof address.houseNumber === "string" && address.houseNumber != "") || address.mailbox && address.mailbox != "" ? false : true;
        setAddressErrors(errors);
    }



    const checkMailbox = () => {
        const address = clientAddress;
        const errors = addressErrors;
        if (!address.mailbox || address.mailbox== "" ) {
            errors.mailbox = true;
        } else {
            errors.houseNumber = false;
        }
        setAddressErrors(errors);
        props.config.onChange(address);
                getPostalCode();

    }

    const onMailboxFocus = () => {
        const address = clientAddress;
        const errors = addressErrors;
        
        errors.mailbox = address.mailbox && address.mailbox != "" || (address.houseNumber && (typeof address.houseNumber === "string" && address.houseNumber != "")) ? false : true;
        setAddressErrors(errors);
    }

    const onPostalCodeFocus = () => {
        const address = clientAddress;
        props.config.onChange(address);
        getPostalCode();
    }

    const getPostalCode = async ()=>{
            // this.setState({postalcodeErrMsg:""})
            setPostalLoading(true);
            const addressData = clientAddress;
            const errors = addressErrors;

            if ((addressData &&  addressData.city &&  addressData.city.length>0
                && addressData.street &&  addressData.street.length>0
                && addressData.houseNumber &&  addressData.houseNumber>0) 
                || (addressData && addressData.city && addressData.city.length > 0 && addressData.mailbox && addressData.mailbox.length > 0)) {
            // 
                    let postal = await simulatorModel.getPostalCode(addressData.city, addressData.street,addressData.houseNumber,addressData.entry, addressData.mailbox);
                    if(postal!=null)
                        addressData.postalCode = postal.postalCode;
                    else{
                        setPostalcodeErrMsg("מיקוד לא נמצא")
                    }
                    
            }
            else {
                addressData.postalCode = "";
            }
            setClientAddress(addressData);
            setPostalLoading(false);
            // if (stateData && stateData.customer && stateData.customer.customerAddresses && stateData.customer.customerAddresses.length > 0 
            //     && stateData.customer.customerAddresses[0].city &&  stateData.customer.customerAddresses[0].city.length>0             
            //     && stateData.customer.customerAddresses[0].mailbox &&  stateData.customer.customerAddresses[0].mailbox.length>0 ) {
            //
            //         var postal = await this.simulatorModel.getPostalCode(stateData.customer.customerAddresses[0].city,"",0,"")
                    
            //         stateData.customer.customerAddresses[0].postalCode = postal.postalCode;
            //         this.setState({ data: stateData });
    
                
            // }
            
        } 

    useEffect(()=>{
        props.config.onChange(clientAddress);
    }, [clientAddress])

    useEffect(()=>{
            if (props.customerAddress.hasError) {
                checkAddress(props.customerAddress);
                console.log('hasError changed from outside');
            }
            console.log('Client Address errors useEffect', addressErrors)
            if(!props.customerAddress.hasError){
                setAddressErrors({
                    city: false,
                    street: false,
                    houseNumber: false,
                    mailbox: false,
                    postalCode: false,
                    addressType: false,
                });
                console.log('Client Address useEffect NO ERRORS', addressErrors)
            }
        }, [props.customerAddress.hasError])

    return (
        
    <div className="parameter-row">
        <div className={`parameter-item ${addressErrors.city ? 'error' : ''}`}>
            <div className="field">
                <div className="value">
                    <input type="text" list="city_list" value={clientAddress.city} onChange={(e:any)=>onParamChange('city', e.target.value)} />
                    <datalist id="city_list">
                        {props.config.cities.map((o: any, i: number)=><option key={i} value={o.value}>{o.text}</option>)}
                    </datalist>
                </div>
                <div className='error-message'>
                {(!clientAddress.city || clientAddress.city == '')  && (<>
                        {fieldRequired}
                        </>)}                
                </div>
            </div>
        </div>
        <div className={`parameter-item ${addressErrors.street ? 'error' : ''}`}>
            <div className="field">
                <div className="value">
                    <input type="text" list={clientAddress.city} value={clientAddress.street} onChange={(e:any)=>onParamChange('street', e.target.value)} />
                    
                    
                    <datalist id={clientAddress.city}>
                        {streetsList.length > 0 && streetsList.map((o:any, i: number)=><option key={i} value={o.value}>{o.text}</option>)}
                    </datalist>
                        {/* <AutoCompleteCities
                        dataValue={clientAddress != null && clientAddress.street  ? clientAddress.street : ""}
                        citiesListData={streetsList.map((street: any) => street.value)}
                        setAdressData={onParamChange}
                        field={'street'}
                        widthInput={'150px'}
                        />
                     */}
                    
                </div>
                <div className='error-message'>
                    {(!clientAddress.mailbox || clientAddress.mailbox == '') && (!clientAddress.street || clientAddress.street == '') && (<>
                        {fieldRequired}
                        </>)}            
                </div>
            </div>
        </div>
        <div className={`parameter-item ${addressErrors.houseNumber ? 'error' : ''}`}>
            <div className="field">
                <div className="value">
                    <input type="text"  value={clientAddress.houseNumber} onChange={(e:any)=>onParamChange('houseNumber', e.target.value)} 
                    onBlur={checkHouseNumber} onFocus={onHouseNumberFocus}
                    />
                </div>
                <div className='error-message'>

                {(!clientAddress.mailbox || clientAddress.mailbox == '') && (!clientAddress.houseNumber || clientAddress.houseNumber == 0) && (<>
                    {'מספר בית או תיבת דואר הינם שדות חובה'}
                </>)}

                </div>
            </div>
        </div>
        <div className="parameter-item">
            <div className="field">
                <div className="value">
                    <input type="text"  value={clientAddress.apartmentNumber} onChange={(e:any)=>onParamChange('apartmentNumber', e.target.value)} />
                </div>
            </div>
        </div>
        <div className="parameter-item">
            <div className="field">
                <div className="value">
                    <input type="text" value={clientAddress.entry} onChange={(e:any)=>onParamChange('entry', e.target.value)} onBlur={onPostalCodeFocus}/>
                </div>
            </div>
        </div>
        <div className={`parameter-item ${addressErrors.mailbox ? 'error' : ''}`}>
            <div className="field">
                <div className="value">
                    <input type="text"  value={clientAddress.mailbox} onChange={(e:any)=>onParamChange('mailbox', e.target.value)} 
                    onBlur={checkMailbox} onFocus={onMailboxFocus} />
                </div>
                <div className='error-message'>

                {(!clientAddress.mailbox || clientAddress.mailbox == '') && (!clientAddress.houseNumber || clientAddress.houseNumber == 0) && (<>
                    {'מספר בית או תיבת דואר הינם שדות חובה'}
                </>)}

                </div>
            </div>
        </div>
        <div className="parameter-item">
            <div className="field">
                <div className="value">
                    <input type="text"  value={clientAddress.postalCode} onChange={(e:any)=>onParamChange('postalCode', e.target.value)} onFocus={onPostalCodeFocus} />
                    <img src={require("../assets/images/loading.gif")} className={postalLoading ? "loadingGif" : "hide"} />
                </div>
            </div>
        </div>
        <div className="parameter-item">
            <div className="field">
                <div className="value">
                    {addressTypes ? (
                        <IDNameDescriptionItemSelect
                            OnChange={onParamChange}
                            Id={"addressType"} Options={addressTypes}
                            Value={clientAddress.addressType}
                         />
                    ) : ""}
                    
                </div>
            </div>
        </div>
        <div className="parameter-item action">
            <div className="icon trash-brown pointer" onClick={onDelete}></div>
        </div>
    </div>
    )
}

export default ClientAddress;